module.exports = "<div class=\"side-log\">\n  <div class=\"log\">\n    <p *ngFor=\"let log of logs\">{{ log }}</p>\n  </div>\n</div>\n"